/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { adminHasPermission, cleanUpLoans } from '../../utils/helpers';
import useCustomQuery from '../../network/useCustomQuery';
import useGetQueryParams from '../../customHooks/useGetQueryParams';
import { GET_ALL_ADMIN_LOANS } from '../../graphql/admin_queries';
import AdminTable from '../../components/AdminTable';
import DashboardHeader from '../../components/DashboardHeader';
import AdminLinkTabs from '../../components/AdminLinkTabs';
import useToast from '../../customHooks/useToast';
import useFilterMethods from '../../customHooks/useFilterMethods';
import EmptyRecord from '../../components/EmptyRecord';
import useTableColumn from '../../customHooks/useTableColumn';
import generatePDF from '../../utils/generatePdf';
import generateCSV from '../../utils/generateCSV';
// import EmptyAdminCuatomerIcon from '../../svgs/EmptyAdminCuatomerIcon';
import EmptyMerchantSettlement from '../../svgs/EmptyMerchantSettlement';
import HorizontalListIcon from '../../svgs/HorizontalListIcon';
import ActiveMerchantIcon from '../../svgs/ActiveMerchantIcon';
import DeactivateMerchantIcon from '../../svgs/DeactivateMerchantIcon';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';
import DeclineLoanModal from './DeclineLoanModal';
import ErrorPermissionModalComp from '../../components/ErrorPermissionModalComp';
import ApproveLoanModal from './ApproveLoanModal';
import { AdminRouteName } from '../CONSTANTS';
import { useGlobalState } from '../../contexts';
import PermissionDenied from '../PermissionDenied';
import CustomerTabs from '../AdminCustomers/CustomerTabs';
// import { useGlobalState } from '../../contexts/AdminGlobalContext';
// import { loadpayfiProduct } from '../../contexts/AdminGlobalContext';

const limit = 14;
interface IMerchantTableRecord{
defaultUrl?:string;
toggleStorageId?:string;
tabStatus?:string;
hasNameAndImage?:boolean;
permissionName:string;
payload?: string;
userId?: string;
subTab?: any;
}
const LoanTableRecords = ({
  defaultUrl, toggleStorageId, tabStatus, hasNameAndImage, permissionName, payload, userId, subTab,
}:IMerchantTableRecord) => {
  const Toast = useToast();
  const { profile } = useGlobalState();
  const adminPermissions = profile?.role?.permissions || [];
  const [getLoans, getLoansLoading, loans] = useCustomQuery({
    query: GET_ALL_ADMIN_LOANS,
    onError: () => {},
    onData: () => {},
  });
  const TabsRaw = [
    {
      id: 1, name: 'All Credits', link: AdminRouteName.loansRoute, permission: 'can-view-all-credit-request-tab',
    },
    {
      id: 2, name: 'Awaiting Approval Credits', link: AdminRouteName.awaitingApprovalLoansRoute, permission: 'can-view-awaiting-approval-credit-request',
    },
    {
      id: 3, name: 'Disbursed Credits', link: AdminRouteName.disbursedLoansRoute, permission: 'can-view-disbursed-credit-request',
    },
    {
      id: 4, name: 'Declined Credits', link: AdminRouteName.declinedLoansRoute, permission: 'can-view-declined-credit-request',
    },
  ];

  const Tabs = TabsRaw?.map((tab) => ({
    ...tab,
    disabled: !adminHasPermission(adminPermissions, tab.permission),
  }));

  const { getQuery, getFilterQueries } = useGetQueryParams();
  const search = getQuery('search') || '';
  const page = Number(getQuery('page'));
  const { push } = useHistory();

  const [approveModal, setApproveModal] = useState(false);
  const [declineModal, setDeclineModal] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);

  const allColumns = [
    ['image', 'email', 'hasBottomValue', 'name'],
    'property',
    'landlord',
    'amount',
    'rentAmount',
    'downPayment',
    'tenor',
    'moratoriumDuration',
    'status',
  ];
  const columnLabelFormat = {
    name: 'Customer',
    property: 'Property',
    amount: 'Loan Amount',
    rentAmount: 'Rent amount',
    downPayment: 'Down Payment',
    tenor: 'Loan Tenor',
    moratoriumDuration: 'Moratorium Duration',
    status: 'Status',
    merchant: 'Merchant',
  };
  const { getColumns, applyChanges, selectedColumns } = useTableColumn(allColumns, toggleStorageId);

  const [loansRec, setloansRec] = useState(null);
  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };
  if (!page) {
    push(`${defaultUrl}?page=1&search=${search}`);
  }

  const onSearchChange = (e) => {
    push(`${defaultUrl}?page=1&search=${encodeURIComponent(e.target.value)}`);
  };

  const handlegetAllCaLoans = useCallback(() => {
    if (page) {
      const result = getFilterQueries();
      getLoans({
        variables: tabStatus ? {
          offset: (page - 1) * limit,
          limit,
          statusFilter: tabStatus,
          search,
          userId,
          filters: {
            from: result.from,
            to: result.to,
            tenor: result?.tenor,
            channel: result.partner,
            status: tabStatus === 'DISBURSED' ? ['ONGOING', 'APPROVED', 'AWAITING_APPROVAL'] : result?.status,
            minAmount: result.min ? Number(result.min) : 0,
            maxAmount: result.max ? Number(result.max) : 0,
          },
        } : {
          offset: (page - 1) * limit,
          limit,
          search,
          userId,
          filters: {
            from: result.from,
            to: result.to,
            tenor: result?.tenor,
            status: result?.status,
            channel: result?.partner,
            minAmount: result?.min ? Number(result?.min) : 0,
            maxAmount: result?.max ? Number(result?.max) : 0,
          },
        },
      });
    }
  }, [page, search]);
  useEffect(() => {
    handlegetAllCaLoans();
  }, [handlegetAllCaLoans]);

  const onFilterSubmit = (result) => {
    getLoans({
      variables: {
        offset: 0,
        limit,
        ...(tabStatus ? { statusFilter: tabStatus } : {}),
        search,
        userId,
        filters: {
          from: result.from,
          to: result.to,
          tenor: result?.tenor,
          status: result?.status,
          channel: result?.partner,
          minAmount: result?.min ? Number(result?.min) : 0,
          maxAmount: result?.max ? Number(result?.max) : 0,
        },
      },
    });
  };

  const {
    filterObj,
  } = useFilterMethods({
    allowedFilters: ['dateRange', ...((!tabStatus) ? ['status'] : []), 'tenor', 'amountRange', 'partner'],
    defaultUrl,
    cb: onFilterSubmit,
    Toast,
    customFilterInformation: {
      dateRange: {
        label: 'Period',
      },
      status: {
        label: 'Status',
        options: [
          {
            label: 'Paid',
            value: 'PAID',
          },
          {
            label: 'Ongoing',
            value: 'ONGOING',
          },
          {
            label: 'Cancelled',
            value: 'CANCELLED',
          },
          {
            label: 'Awaiting Approval',
            value: 'AWAITING_APPROVAL',
          },
          {
            label: 'Approved',
            value: 'APPROVED',
          },
        ],
      },
      amountRange: {
        label: 'Amount',
      },
      partner: {
        label: 'Partner',
      },
    },
  });

  useEffect(() => {
    if (loans?.getAllCaLoans?.loans) {
      setloansRec(loans?.getAllCaLoans);
    }
  }, [loans]);
  const [getExportRecord] = useCustomQuery({
    query: GET_ALL_ADMIN_LOANS,
    onError: () => {},
    onData: () => {},
  });

  const handleExport = async (type: string) => {
    try {
      const result = getFilterQueries();
      const output = await getExportRecord({
        variables: {
          offset: 0,
          limit: 2000,
          ...(tabStatus ? { statusFilter: tabStatus } : {}),
          search,
          userId,
          filters: {
            from: result?.from,
            to: result?.to,
            status: result?.status,
            channel: result?.partner,
            minAmount: result?.min ? Number(result?.min) : 0,
            maxAmount: result?.max ? Number(result?.max) : 0,
            tenor: result?.tenor,
          },
        },
      });
      if (output?.data?.getAllCaLoans?.loans) {
        const rec = cleanUpLoans(output?.data?.getAllCaLoans?.loans);
        const func = type === 'pdf' ? generatePDF : generateCSV;
        const selectedHeaders = [
          'S/N',
          // change image__email__hasBottomValue__name concated columns to a single column of name
          ...(getColumns?.()?.map((column) => (column === 'image__email__hasBottomValue__name' ? ['name', 'email'] : column)) || []),
        ];

        func({
          payload: rec,
          title: 'LOANS',
          selectedHeaders,
          formatHeaders: columnLabelFormat,
          cb: () => Toast.success('Exported successfully'),
        });
      }
    } catch (error) {
      Toast.error('Error while exporting');
    }
  };

  const dropdownData = [{ title: 'Approve Loan', color: '#05603A', icon: <ActiveMerchantIcon /> }, { title: 'Decline Loan', color: '#D92D20', icon: <DeactivateMerchantIcon /> }];

  const handleDropdown = (dropdownTitle:any, data) => {
    if (dropdownTitle === 'Approve Loan') {
      setApproveModal(true);
    }
    if (dropdownTitle === 'Decline Loan') {
      setDeclineModal(true);
    }
    setSelectedLoan(data);
  };

  return (
    <div>
      <DashboardHeader
        title="Credit Request"
        smallSubTitle={`(${loansRec?.count || 0})`}
        searchPlaceholder="Search by reference no, email address, merchant and customer name "
        search={search}
        onSearchChange={onSearchChange}
        searchLoading={getLoansLoading}
        filterObj={filterObj}
        columnObject={{
          allColumns,
          formatLabels: columnLabelFormat,
          applyChanges,
          selectedColumns,
        }}
        exportObj={{
          handleExport,
        }}
        disableExport={!adminHasPermission(adminPermissions, 'can-export-credit-request-records')}
        disableSearch={!adminHasPermission(adminPermissions, 'can-search-credit-request-records')}
        disbleFilter={!adminHasPermission(adminPermissions, 'can-filter-credit-request-records')}
        payload={payload}

      >
        <AdminLinkTabs>

          <CustomerTabs Tabs={userId ? subTab : Tabs} />

        </AdminLinkTabs>
      </DashboardHeader>
      <RolesAndPermissionGuard permissionName={permissionName} hasErrorTemplate={<PermissionDenied height="60vh" />}>

        <div className="merchant-table-details-cover">
          {loansRec?.count ? (
            <AdminTable
              refreshing={getLoansLoading}
              page={page}
              setPage={setPage}
              pageSize={limit}
              minHeight="calc(100vh - 280px)"
              count={loansRec?.count}
              contents={cleanUpLoans(loansRec?.loans)}
              reference="id"
              hideDominantImage
              clickable
              hasNameAndImage={hasNameAndImage}
              handleClick={(data) => push(`/loans/loans-details/${data?.id}`)}
              allowKeyArr={getColumns(true)}
              mobileAllowKeyArr={
                [
                  'status',
                  ['name', 'payfiId'],
                  ['paymentChannel', 'amount'],
                ]
              }
              formatLabels={columnLabelFormat}
              tableStatus={tabStatus}
              dropDownIcon={<HorizontalListIcon color="#667085" />}
              dropdownData={dropdownData}
              handleDropdown={handleDropdown}
              handleSelectDropdown={handleDropdown}
            />
          ) : (
            <EmptyRecord
              height="calc(100vh - 240px)"
              title={getLoansLoading ? 'Fetching loans...' : 'No loans found'}
              main="All loans will appear here on the dashboard."
              // footer="Receive Payments"
              loading={getLoansLoading}
              Icon={EmptyMerchantSettlement}
            />
          )}

        </div>
      </RolesAndPermissionGuard>
      {
        approveModal && <RolesAndPermissionGuard permissionName="can-approve-user" hasErrorTemplate={<ErrorPermissionModalComp closeModal={() => setApproveModal(false)} />}><ApproveLoanModal handlegetAllCaLoans={handlegetAllCaLoans} loanId={selectedLoan?.id} closeModal={() => setApproveModal(false)} /></RolesAndPermissionGuard>
      }
      {
        declineModal && (
          <RolesAndPermissionGuard permissionName="can-decline-user" hasErrorTemplate={<ErrorPermissionModalComp closeModal={() => setDeclineModal(false)} />}>
            <DeclineLoanModal handlegetAllCaLoans={handlegetAllCaLoans} loanId={selectedLoan?.id} closeModal={() => setDeclineModal(false)} />
          </RolesAndPermissionGuard>
        )
      }
    </div>
  );
};
export default LoanTableRecords;
